import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/gakarod" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/vaibhav-anand-04079b160/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
      <p>A portfolio inspired by the <a href="https://github.com/yujisatojr/react-portfolio-template" target="_blank" rel="noreferrer">classic react template</a></p>
    </footer>
  );
}

export default Footer;